import {
  Method,
  TransferOptions,
} from "../../../core/models/entities/TransferOptions";
import { TransferDto } from "../responses/transferOptionsDto";

export function mapTransferOptions(dto: TransferDto[]): TransferOptions {
  return {
    // Null-guard: a degraded 200 with an empty body must not throw in the
    // query transform (the consuming pricing sections would show the error
    // view and never heal).
    transferMethods: dto ? dto.map(mapToTransfer) : [],
  };
}

function mapToTransfer(dto: TransferDto): Method {
  return {
    methodKey: dto.key,
    displayName: dto.displayName,
    priceType: dto.priceType,
    options: dto.sizes,
    type: dto.type,
  };
}
